import { render, staticRenderFns } from "./member_modal_relation.vue?vue&type=template&id=30e90f8c&"
import script from "./member_modal_relation.vue?vue&type=script&lang=js&"
export * from "./member_modal_relation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports